"use client";

import { motion } from "framer-motion";
import Navbar from "@/app/components/Navbar";
import Footer from "@/app/components/Footer";

export default function RefundClient() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen px-6 py-32" style={{ background: "#0A0908" }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mx-auto"
        >
          <h1
            className="text-3xl md:text-4xl font-light mb-2"
            style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}
          >
            Cancellation & Refund Policy
          </h1>
          <p
            className="text-xs mb-12"
            style={{ color: "rgba(245,240,232,0.3)", fontFamily: "'Montserrat', sans-serif" }}
          >
            Last updated: May 2024
          </p>

          <div className="space-y-8 text-sm leading-relaxed" style={{ color: "rgba(245,240,232,0.6)", fontFamily: "'Montserrat', sans-serif" }}>
            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                1. Subscription Cancellation
              </h2>
              <p>
                You may cancel your Aurelius & Co subscription at any time through your dashboard settings. Upon cancellation, your subscription will remain active until the end of your current billing period. After this period, your access to premium features will be revoked.
              </p>
            </section>

            <section style={{ border: "1px solid rgba(239,68,68,0.2)", padding: "1.5rem", background: "rgba(239,68,68,0.02)" }}>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F87171", fontFamily: "'Cormorant', serif" }}>
                2. No Refund Policy
              </h2>
              <p className="mb-4" style={{ color: "rgba(245,240,232,0.8)" }}>
                <strong>Strictly No Refunds:</strong> Aurelius & Co operates on a "No Refund" policy for all its subscription plans. Once a payment is processed, it is non-refundable.
              </p>
              <p>
                By subscribing to our services, you acknowledge and agree that:
              </p>
              <ul className="space-y-2 mt-3 pl-4">
                <li>• No partial or full refunds will be issued for unused portions of a subscription.</li>
                <li>• Cancellation of a subscription does not entitle you to any refund.</li>
                <li>• We do not provide credits or refunds for any accidental double payments (unless proven to be a system error).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                3. Service Downtime and Issues
              </h2>
              <p>
                While we strive for 99.9% uptime, we are not liable for any losses incurred due to service interruptions, API changes from Meta/Instagram, or technical issues beyond our control. These events do not constitute grounds for a refund.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                4. Policy Changes
              </h2>
              <p>
                We reserve the right to modify this Cancellation & Refund Policy at any time. Any changes will be posted on this page with an updated "Last updated" date. Continued use of our service after such changes constitutes acceptance of the new policy.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-light mb-3" style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}>
                5. Contact
              </h2>
              <p>
                If you have any questions regarding our billing or cancellation policies, please reach out to our billing support team at billing@aureliusco.com.
              </p>
            </section>
          </div>
        </motion.div>
      </main>
      <Footer />
    </>
  );
}
